import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { safeGetItem } from '../utils/safe-storage';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor() { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const url = request.url.toLowerCase();
        const isLoginEndpoint = url.endsWith('/auth') && request.method === 'POST' && request.body instanceof FormData;
        const isExternalUrl = !url.includes(environment.HOST.FAST_API_URL) && 
                              !url.includes(environment.HOST.HOST_API_URL) &&
                              !url.includes(environment.HOST.HIRE_GENAI_URL) &&
                              !url.includes(environment.HOST.HIRE_PULSE_URL);

        if (isExternalUrl && !url.includes(environment.HOST.HIRE_GENAI_URL) && !url.includes(environment.HOST.HIRE_PULSE_URL)) {
            return next.handle(request);
        }

        const companyUUID = safeGetItem('companyUUID') || '';
        const companyDetails = safeGetItem('company-details');
        const schoolId = companyDetails ? JSON.parse(companyDetails)?.company_settings?.school_code || '' : '';
        const jobId = safeGetItem('selectedJobId') || safeGetItem('eventId') || '';

        // Get tokens
        const candidateTokenString = safeGetItem('token');
        const candidateToken = candidateTokenString ? JSON.parse(candidateTokenString) : null;

        const fastApiTokenString = safeGetItem('tokenFastApi');
        const fastApiToken = fastApiTokenString ? JSON.parse(fastApiTokenString) : null;

        // Check if request wants to use candidate token
        const useCandidateToken = request.headers.get('use-candidate-token') === 'true';
        const needsTokenHeader = url.includes('/candidates/interviews/details') ||
                                (url.includes('/candidates/') && url.includes('/interviews/open-ide')) ||
                                (url.includes('/candidates/') && url.includes('/update-status') && !url.includes('/admin/'));
        
        let authToken = '';
        let candidateTokenValue = '';
        if (!isLoginEndpoint) {
            if (useCandidateToken) {
                if (candidateToken) {
                    if (needsTokenHeader) {
                        candidateTokenValue = candidateToken.access_token || '';
                    } else {
                        const tokenType = candidateToken.token_type || 'Bearer';
                        authToken = `${tokenType} ${candidateToken.access_token}`;
                    }
                }
            } else {
                if (fastApiToken) {
                    const tokenType = fastApiToken.token_type || 'Bearer';
                    authToken = `${tokenType} ${fastApiToken.access_token}`;
                }
            }
        }

        const headers: { [key: string]: string } = {};

        request.headers.keys().forEach(key => {
            const lowerKey = key.toLowerCase();
            if (lowerKey !== 'use-candidate-token' && 
                lowerKey !== 'authorization' && 
                lowerKey !== 'token' &&
                lowerKey !== 'company-uuid' &&
                lowerKey !== 'origin' &&
                lowerKey !== 'schoolid' &&
                lowerKey !== 'jobid') {
                const value = request.headers.get(key);
                if (value) {
                    headers[key] = value;
                }
            }
        });

        if (!headers['Content-Type'] && !headers['content-type']) {
            if (!(request.body instanceof FormData)) {
                headers['Content-Type'] = 'application/json';
            }
        }

        if (needsTokenHeader && candidateTokenValue && !isLoginEndpoint) {
            headers['token'] = candidateTokenValue;
        } else if (authToken && !isLoginEndpoint) {
            headers['Authorization'] = authToken;
        }

        if (companyUUID && (url.includes(environment.HOST.FAST_API_URL) || 
                           url.includes(environment.HOST.HIRE_GENAI_URL) || 
                           url.includes(environment.HOST.HIRE_PULSE_URL))) {
            headers['company-uuid'] = companyUUID;
        }

        if (url.includes(environment.HOST.HOST_API_URL)) {
            headers['Origin'] = window.location.origin;
        }

        if (schoolId && url.includes(environment.HOST.HOST_API_URL)) {
            headers['schoolid'] = schoolId;
        }

        if (jobId && url.includes(environment.HOST.HOST_API_URL)) {
            headers['jobId'] = jobId;
        }

        const domainHeader = request.headers.get('domain');
        if (domainHeader) {
            headers['domain'] = domainHeader;
        }

        const updatedRequest = request.clone({
            setHeaders: headers
        });

        return next.handle(updatedRequest);
    }
}
